// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.edit-upload-field {
    border: 1px solid var(--border-color);
    display: flex;
    align-items: center;
    background-color: var(--input-bg-color);
    padding: 0.25em;
}

span.edit-upload-field > a {
    flex: 1 1 auto;
    white-space: nowrap;
}

span.edit-upload-field > span.icon {
    flex: 0 0 auto;
}

span.edit-upload-field-input {
    display: flex;
    align-items: center;
}

span.edit-upload-field-input > input {
    min-width: 8em;
    width: 0;
    flex: 1 1 auto;
}

span.edit-upload-field-input > span.icon {
    flex: 0 0 auto;
    margin: 0 0.25em;
}

span.edit-upload-field-disabled,
span.edit-upload-field-input-disabled {
    background-color: var(--input-bg-color-disabled);
    color: var(--text-color-disabled);
}

span.edit-upload-field-image {
    display: flex;
    flex-direction: column;
    max-width: 150px;
}

span.edit-upload-field-image > img {
    width: 100%;
    flex: 1 1 auto;
    cursor: pointer;
}

span.edit-upload-field-image > div.ButtonBar {
    margin: 0;
}

span.edit-upload-field-imagelink {
    position: relative;
    text-align: left;
}

span.edit-upload-field-imagelink > img {
    display: none;
    position: absolute;
    max-width: 240px;
    max-height: 240px;
    top: 100%;
    z-index: 1;
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
    cursor: pointer;
}

span.edit-upload-field-imagelink:hover > img {
    display: initial;
}

video.edit-capture-frame {
    height: 100%;
    max-width: 100%;
}

div.edit-capture-controls {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 1em;
    left: 0;
    right: 0;
}

div.edit-capture-controls > span.icon {
    font-size: 300%;
    background-color: rgba(255, 255, 255, 0.75);
    padding: 0.3em;
    border-radius: 1em;
}
`, "",{"version":3,"sources":["webpack://./../qwc2/components/style/EditUploadField.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,gDAAgD;IAChD,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,2CAA2C;IAC3C,cAAc;IACd,kBAAkB;AACtB","sourcesContent":["span.edit-upload-field {\n    border: 1px solid var(--border-color);\n    display: flex;\n    align-items: center;\n    background-color: var(--input-bg-color);\n    padding: 0.25em;\n}\n\nspan.edit-upload-field > a {\n    flex: 1 1 auto;\n    white-space: nowrap;\n}\n\nspan.edit-upload-field > span.icon {\n    flex: 0 0 auto;\n}\n\nspan.edit-upload-field-input {\n    display: flex;\n    align-items: center;\n}\n\nspan.edit-upload-field-input > input {\n    min-width: 8em;\n    width: 0;\n    flex: 1 1 auto;\n}\n\nspan.edit-upload-field-input > span.icon {\n    flex: 0 0 auto;\n    margin: 0 0.25em;\n}\n\nspan.edit-upload-field-disabled,\nspan.edit-upload-field-input-disabled {\n    background-color: var(--input-bg-color-disabled);\n    color: var(--text-color-disabled);\n}\n\nspan.edit-upload-field-image {\n    display: flex;\n    flex-direction: column;\n    max-width: 150px;\n}\n\nspan.edit-upload-field-image > img {\n    width: 100%;\n    flex: 1 1 auto;\n    cursor: pointer;\n}\n\nspan.edit-upload-field-image > div.ButtonBar {\n    margin: 0;\n}\n\nspan.edit-upload-field-imagelink {\n    position: relative;\n    text-align: left;\n}\n\nspan.edit-upload-field-imagelink > img {\n    display: none;\n    position: absolute;\n    max-width: 240px;\n    max-height: 240px;\n    top: 100%;\n    z-index: 1;\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n    cursor: pointer;\n}\n\nspan.edit-upload-field-imagelink:hover > img {\n    display: initial;\n}\n\nvideo.edit-capture-frame {\n    height: 100%;\n    max-width: 100%;\n}\n\ndiv.edit-capture-controls {\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    bottom: 1em;\n    left: 0;\n    right: 0;\n}\n\ndiv.edit-capture-controls > span.icon {\n    font-size: 300%;\n    background-color: rgba(255, 255, 255, 0.75);\n    padding: 0.3em;\n    border-radius: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
